import styled from 'styled-components';
import { BodyBoldS, HeadingExtraBoldL } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';
import BuildingIcon from '@/assets/icons/companyIcon.svg?react';
import InfoGreyIcon from '@/assets/icons/infogrey.svg?react';

export const ReportDetailsCont = styled.div`
  position: relative;
`;

export const ReportName = styled(HeadingExtraBoldL)`
  position: relative;
  width: 734px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const DetailsCont = styled.div`
  ${({ theme }) => `
    display: flex;
    margin: ${theme.layout.spacing.centy} 0 0 0;
    flex-flow: row wrap;
    align-items: center;
    font-size: 16px;
    line-height: 19px;
    gap: 8px 24px;
  `};
`;

export const DetailCont = styled.div`
  display: flex;
  align-items: center;
`;

export const BoldedText = styled(BodyBoldS)`
  ${({ theme }) => `
    margin: 0 0 0 ${theme.layout.spacing.nano};
  `};
`;

export const ReportType = styled(BoldedText)`
  text-transform: capitalize;
`;

export const CompanyIcon = styled(BuildingIcon)`
  ${({ theme }) => `
    margin: 0 ${theme.layout.spacing.mikro} 0 0;
  `};
`;

export const InfoIcon = styled(InfoGreyIcon)`
  path {
    ${({ theme }: IThemeProvider) => `
    fill: ${theme.colors.neutral.primary[80]};
`}
  }
`;

export const TooltipCont = styled.div`
  text-align: justify;
  ${({ theme }: IThemeProvider) => `
  margin: 0 0 0 ${theme.layout.spacing.mikro};
`}
`;

export const ResponseRateCont = styled.div`
  ${({ theme }: IThemeProvider) => `
    margin-left: ${theme.layout.spacing.mikro};
`}
`;

export const SpinnerCont = styled.div`
  position: fixed;
  z-index: 1;
  top: 50%;
  left: 50%;

  .ant-spin-dot {
    font-size: 60px;

    .ant-spin-dot-item {
      width: 23.83px;
      height: 23.83px;
    }
  }
`;
